module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/arrow-right-85c8fd7e3ddae983d2ae05931f4a9cb7.svg&quot;;"